import api from './api';

// Uses the shared axios instance so requests carry the Shopify session token
// (see api.js interceptor) and hit the same backend base URL.
const shopifyApi = {
  // Get Shopify products (paginated)
  getProducts: async (searchQuery = '', options = {}) => {
    const params = {};
    if (searchQuery) params.search = searchQuery;
    if (options.limit) params.limit = options.limit;
    if (options.cursor) params.cursor = options.cursor;
    if (options.excludeDkRental) params.excludeDkRental = 'true';
    const response = await api.get('/api/shopify/products', { params });
    return response.data;
  },

  // Get a specific Shopify product
  getProduct: async (productId) => {
    const response = await api.get(`/api/shopify/products/${productId}`);
    return response.data;
  },

  // Get variants for a product
  getProductVariants: async (productId, shop) => {
    const response = await api.get(`/api/shopify/products/${productId}/variants`, {
      params: { shop }
    });
    return response.data;
  },

  // Search products
  searchProducts: async (query, shop) => {
    const response = await api.get('/api/shopify/products/search', {
      params: { q: query, shop }
    });
    return response.data;
  },

  // Get products by IDs
  getProductsByIds: async (ids) => {
    const response = await api.post('/api/shopify/products/by-ids', { ids });
    return response.data;
  },

  // Add tags to a Shopify product
  addProductTags: async (productId, tags) => {
    const response = await api.post(`/api/shopify/products/${productId}/tags`, { tags });
    return response.data;
  }
};

export default shopifyApi;
